<!-- 
程式：selfInputPoliyNumber.vue
功能：自行輸入國泰壽險保單號碼
作者：i94005ws02 邱琬琪
完成：2020-11-04
-->
<template>
  <div class="tab-pane pt-3 active show">
    <div class="insurance-editor">
      <div class="col-12">
        <h4><span class="text-thin">分類：</span>自行輸入國泰人壽保單號碼</h4>
        <div class="panel panel-form">
          <div
            style="height: 95px"
            class="panel insurance-item"
            v-for="(insure, i) in insurances"
            :key="`insure-item-${i}`"
          >
            <div class="col-1 no">{{ i + 1 }}</div>
            <div class="col-4 form-group form-group-inline">
              <label><span class="text-red">*</span>主被保人</label>
              <select
                class="form-control form-control-inline form-wide"
                v-model="insure.insuredID"
                :data-vv-name="`insuredID-${i}`"
                :class="{ 'is-invalid': errors.has(`insuredID-${i}`) }"
                v-validate="'required'"
                alt="ch"
              >
                <option value="">請選擇</option>
                <option
                  v-for="(item, index) in toOpenNameSel()"
                  :key="index"
                  :value="item.csidno"
                >
                  {{ item.name | truncate }}
                </option>
              </select>
              <div class="mt-2 text-right" v-if="errors.has(`insuredID-${i}`)">
                <label class="text-danger mr-5">請選擇主被保人</label>
              </div>
            </div>
            <div class="col-4 form-group form-group-inline">
              <label class="col-1 pr-0"
                ><span class="text-red">*</span>保單號碼</label
              >
              <input
                :data-vv-name="`plcno-${i}`"
                :data-vv-as="`保單號碼${insure.policyNumber}`"
                v-validate="{
                  required: true,
                  duplicate: insurances
                    .filter((x, j) => j !== i && x.policyNumber)
                    .map((x) => x.policyNumber)
                }"
                :class="{ 'is-invalid': errors.has(`plcno-${i}`) }"
                type="text"
                class="form-control form-control-inline"
                v-model="insure.policyNumber"
                maxlength="12"
                @input="checkPolicyNumber(i)"
              />
              <div class="mt-2 text-right" v-if="errors.has(`plcno-${i}`)">
                <label class="text-danger mr-4">
                  {{ errors.first(`plcno-${i}`) }}</label
                >
              </div>
            </div>
            <div class="action text-right">
              <button
                v-if="i > 0"
                type="button"
                class="btn btn-default form-control-inline"
                @click="deleteInsurance(i)"
              >
                刪除
              </button>
            </div>
          </div>
          <div
            class="panel insurance-item add text-center"
            role="button"
            @click="AddInsurance()"
          >
            <div class="content text-center">
              <i class="icon-add_new text-orange"></i>
              <span class="text ml-1">新增保單</span>
            </div>
          </div>
          <div class="error-block d-inline-block mb-0">
            <span class="error">
              ＊ <span class="text-black">注意事項</span>
            </span>
          </div>
          <div class="note pl-2">
            <p class="text-bold">請輸入「完整」國泰人壽保單號碼。</p>
            <p class="text-bold">保單號碼最多12碼，不能輸入中文。</p>
            <p class="text-danger text-bold">
              ※主被保人需有ID，無ID客戶請先編輯客戶資料，輸入ID後才能建立保單。
            </p>
          </div>
          <div class="row justify-content-center">
            <div class="checkbox checkbox-inline">
              <input type="checkbox" v-model="confirm_checkbox" id="edit_is_permit" />
              <label class="text-red text-bold" for="edit_is_permit">
                已確實取得客戶(準客戶)同意，進行資料編輯
              </label>
            </div>
          </div>
        </div>
        <div class="action mt-2 text-right">
          <a
            @click="cancelAdd()"
            type="button"
            role="button"
            class="btn btn-default"
            >取消</a
          >
          <a
            v-if="$route.query.canBackToMenu"
            @click="toMenu()"
            type="button"
            role="button"
            class="btn btn-default"
            >回上一步</a
          >
          <a
            @click="submit()"
            type="button"
            role="button"
            class="btn btn-primary"
            >確定</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonMixin from "./common";
import { commonMixin as GlobalMixins } from "@/mixins/common";
import { Validator } from "vee-validate";
import {
  insertSelfInputPolicyNumber,
  getQueryPlcnoIdnoFamily,
  getSelfCheckMsg,
  insertDataCollectionLog
} from "@/service";

Validator.extend("plcno", {
  getMessage: "保單號碼格式錯誤",
  validate: (value) => {
    const pattern = new RegExp("^[a-zA-Z0-9]{1,12}$");
    if (!pattern.test(value)) {
      return false;
    }
    return true;
  }
});
export default {
  mixins: [CommonMixin, GlobalMixins],
  data() {
    return {
      options: {},
      insurances: [
        {
          policyNumber: "",
          insuredID: ""
        }
      ],
      familyDatas: [],
      panelIndex: null,
      selfPlcno: this.$route.query.selfPlcno, //家戶回上一頁過來
      confirm_checkbox: false
    };
  },
  mounted() {
    if (this.selfPlcno) {
      this.insurances = JSON.parse(localStorage.insurances);
    }
  },
  methods: {
    //主被保人sel
    toOpenNameSel() {
      return this.options.families.filter(
        (x) => x.csidno && !x.csidno.includes("~")
      );
    },
    //檢查保單號碼
    checkPolicyNumber(index) {
      this.insurances[index].policyNumber = this.insurances[
        index
      ].policyNumber.replace(/[^a-zA-Z0-9]+/g, "");
    },
    async AddInsurance() {
      if (!(await this.checkValidate())) {
        this.insurances.push({
          policyNumber: "",
          insuredID: ""
        });
      }
      this.registerHanlink(); // for 難字更新
    },
    async checkValidate() {
      return new Promise(async (resolve) => {
        if (await this.$validator.validateAll()) {
          resolve();
        } else {
          const errorRuls = this.errors.items.map((x) => x.rule);
          if (errorRuls.filter((x) => x === "required").length) {
            this.$toast.info({ title: "尚有欄位未填，請確認" });
          }
        }
      });
    },
    async submit() {
      if(!this.confirm_checkbox){
        this.$toast.info({title: '未經客戶同意編輯資料'})
        return
      }
      const user = JSON.parse(localStorage.userItems);
      var isDataCorrect = true;
      await this.checkValidate();
      if (!this.isReCorrect(this.insurances)) {
        isDataCorrect = false;
        return;
      }
      if (!(await this.getSelfCheck(user.agidno, this.insurances))) {
        isDataCorrect = false;
        return;
      }

      if (isDataCorrect) {
        for (let insurance of this.insurances) {
          //是否包含家庭型保單
          if (
            await this.getQueryPlcnoIdnoFamilyMsg(
              user.agidno,
              insurance.insuredID,
              insurance.policyNumber
            )
          ) {
            //家庭型保單取該被保人的第一筆保單即可
            let checkFamilyDatas = this.familyDatas.filter(
              (x) => x.csid === insurance.insuredID
            );
            if (checkFamilyDatas && checkFamilyDatas.length === 0) {
              let rAry = this.options.families.filter(
                (x) => x.csidno === insurance.insuredID
              );
              this.familyDatas.push({
                csid: insurance.insuredID,
                plcno: insurance.policyNumber,
                sex: rAry[0].sex,
                name: rAry[0].name,
                age: rAry[0].age
              });
            }
          }
        }
        if (this.familyDatas.length > 0) {
          localStorage.familyDatas = JSON.stringify(this.familyDatas);
          localStorage.insurances = JSON.stringify(this.insurances);
          this.$router.push({
            name: "add-contract-family-relation",
            query: { selfPlcno: true }
          });
        } else {
          const trn_cd = "MV_SELF_INPUT_NUMBER"
          insertDataCollectionLog(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, trn_cd).then(result => {
            if(!result.header || !result.header.status === '200') {
                if(result.header.message) {
                  this.$toast.info({title: result.header.message})
                } else {
                  this.$toast.info({title: `${resMessage}`})
                }     
            }
          })

          insertSelfInputPolicyNumber(
            this.$store.state.userInfo.id,
            this.insurances
          ).then((result) => {
            if (result.header && result.header.status === "200") {
              this.$toast.info({ title: "新增成功" });
              this.$router.push({
                name: "policyInfo-edit-list",
                query: {
                  modify: this.insurances.map((x) => x.policyNumber).join(",")
                }
              });
            } else {
              if (result.header && result.header.message) {
                this.$toast.info({ title: result.header.message });
              } else {
                this.$toast.info({ title: "新增失敗" });
              }
            }
          });
        }
      }
    },
    //檢核
    async getSelfCheck(userId, insurances) {
      const result = await getSelfCheckMsg(userId, insurances);
      if (result.header && result.header.status === "200") {
        let rtnListA = result.body.rtnListA;
        let rtnListB = result.body.rtnListB;
        let rtnListC = result.body.rtnListC;

        let dataIsValid = true;
        
        //【保單號碼1、保單號碼2:已重複或已存在於CRM】
        if (rtnListA && rtnListA.length > 0) {
          let plcno = rtnListA.map((x) => x.PLCNO);
          this.$toast.info({
            title: `保單號碼 ${plcno} : 已存在於CRM `
          });
          dataIsValid = false;
        }
        //【保單號碼1、保單號碼2:自行輸入國泰人壽保單新增失敗：請確認保單號碼或保單效力，若為保代/直效件請用「其他同業壽險保單」方式輸入】
        if (rtnListB && rtnListB.length > 0) {
          let plcno = rtnListB.map((x) => x.PLCNO);
          this.$toast.info({
            title: `保單號碼 ${plcno} : 自行輸入國泰人壽保單新增失敗：請確認保單號碼或保單效力，若為保代/直效件請用「其他同業壽險保單」方式輸入 `
          });
          dataIsValid = false;
        }
        //【保單號碼1、保單號碼2:自行輸入國泰人壽保單新增失敗：請確認該保單「被保人身分證字號」及「保單號碼」是否正確】
        if (rtnListC && rtnListC.length > 0) {
          let plcno = rtnListC.map((x) => x.PLCNO);
          this.$toast.info({
            title: `保單號碼 ${plcno} : 自行輸入國泰人壽保單新增失敗：請確認該保單「被保人身分證字號」及「保單號碼」是否正確`
          });
          dataIsValid = false;
        }
        if (dataIsValid) {
          return true;
        }
        return false;
      }
      return false;
    },
    //是否重複輸入保單號碼
    isReCorrect(familyDatas) {
      let rAry = familyDatas.map((item) => item.policyNumber);
      if (new Set(rAry).size != rAry.length) {
        this.$toast.info({
          title: `您輸入的保單號碼 ${[...new Set(rAry)]} 已重複`
        });
        return false;
      }
      return true;
    },
    //查詢是否為家庭型保單
    async getQueryPlcnoIdnoFamilyMsg(userId, idno, plcno) {
      const result = await getQueryPlcnoIdnoFamily(userId, idno, plcno);
      if (result.header && result.header.status === "200") {
        let selfData = result.body.dataList;
        return !!selfData;
      }
      return false;
    },
    deleteInsurance(i) {
      this.insurances.splice(i, 1);
    },
    //姓名的刪除動作
    deleteIntr(i) {
      this.insurances[i].insuredID = "";
      this.insurances[i].name = "";
    }
  }
};
</script>
